<template>
  <span>
    <el-form-item class="ss-view-item" :label="label">
      <!-- <span v-if="tprop.propertyCode=='100107'">
        <el-input
          :placeholder="tlist2.placeholder"
          size="mini"
          v-model="valueInput"
          >{{ valueInput }}</el-input>
      </span> -->
      <!-- <span v-else-if="tprop.propertyCode=='100310'"></span> -->
      <div style="display:flex;flex-direction: row;">
        <div>
          <el-input
          :placeholder="tlist2.placeholder"
          size="mini"
          v-model="valueInput"
          >{{ valueInput }}</el-input>
        </div>
        <div>
          <span>{{ unit }}</span>
        </div>
      </div>
      
      
    </el-form-item>
  </span>
</template>

<script>
export default {
  data() {
    return {
      valueInput: this.objInput,
      unit: "",
      spanitem: this.spanitem,
      tlist2: this.tprop,
    };
  },
  props: {
    objInput: {
      type: String,
    },
    label: {
      type: String,
    },
    tprop: {
      type: Object,
    }
  },
  watch: {
    objInput(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.valueInput = newVal;
      }
    },
    tprop: {
      handler(newVal, oldVal) {
        console.log('trop',this.tprop)
        if (newVal != oldVal) {
          this.getUnit();
        }
      },
      immediate: true,
      deep: true,
    },
    valueInput(newVal, oldVal) {
      if (newVal !== oldVal) {
        //console.log("myinpuy", this.tprop);
        // if (this.tprop.propertyCode == "100107") {
        //   this.$emit("changeInvoiceNum", this.valueInput);
        // } else if (this.tprop.propertyCode == "100310") {
        //     this.$emit("changeExtensionNumVal", this.valueInput);
        // }else {
          this.tprop.propertyValue = newVal
          this.tprop.propertyValueName = newVal
        // }
      }
    },
  },
  created() {
    this.getUnit();
  },
  methods: {
    getUnit: function() {
      let b = false;
      if (this.tprop) {
        if (this.tprop.rules && this.tprop.rules.length > 0) {
          let rules = JSON.parse(this.tprop.rules);
          let unit = rules.unit;
          this.unit = unit;
          b = true;
        }
      }
      if (!b) {
        this.unit = "";
      }
    },
  },
};
</script>
<style lang="scss">
// .ss-view-item {
//   margin-left: 100px;
//   width: 100px;
// }
</style>
